import {ChangeEvent, FC} from 'react'

interface InputProps {
    type?: 'text' | 'number' | 'email' | 'password'
    label?: string
    value?: string | number
    name?: string
    placeholder?: string
    error?: boolean
    disabled?: boolean
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: any) => void;
    className?: string;
    minValue?: number;
    maxValue?: number;
}

const Input: FC<InputProps> = ({
                                   type,
                                   label,
                                   value,
                                   name,
                                   placeholder,
                                   error,
                                   disabled,
                                   onChange,
                                   onKeyDown,
                                   className,
                                   minValue,
                                   maxValue
                               }) => {
    return (
        <div className="input-wrapper mt-2">
            <div className='standard-input-label-div'>
                <label className='standard-input-label' htmlFor={label}>{label}</label>
            </div>
            <div className='standard-input-div'>
                <input
                    type={type}
                    id={label}
                    value={value}
                    name={name}
                    placeholder={placeholder}
                    onChange={onChange}
                    disabled={disabled}
                    min={minValue}
                    max={maxValue}
                    className={className ? className : 'standard-input'}
                    onKeyDown={onKeyDown}
                />
            </div>
            {error && <p className="error">Input filed can't be empty!</p>}
        </div>
    )
}


export default Input